import React from 'react';

interface TemplateSelectorProps {
    programs: any[];
    programDays: any[];
    selectedProgramId: string | null;
    selectedDayId: string | null;
    isLoading: boolean;
    onProgramChange: (id: string) => void;
    onDayChange: (id: string) => void;
}

/**
 * TemplateSelector: Handles program and training day selection for Performance events.
 * SHADOW VERSION (.tsx)
 */
export const TemplateSelector: React.FC<TemplateSelectorProps> = ({
    programs,
    programDays,
    selectedProgramId,
    selectedDayId,
    isLoading,
    onProgramChange,
    onDayChange
}) => {
    const selectStyle: React.CSSProperties = { 
        all: 'unset', 
        backgroundColor: '#111', 
        border: '1px solid #222', 
        borderRadius: '8px', 
        padding: '10px', 
        color: '#fff', 
        fontSize: '13px', 
        width: '100%', 
        boxSizing: 'border-box' 
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '25px' }}>
            <select 
                value={selectedProgramId || ''} 
                onChange={(e) => onProgramChange(e.target.value)} 
                style={selectStyle}
                aria-label="Select Program"
            >
                <option value="">- Select Program -</option>
                {(programs || []).map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                ))}
            </select>

            {selectedProgramId && (
                <select 
                    value={selectedDayId || ''} 
                    onChange={(e) => onDayChange(e.target.value)} 
                    style={{ ...selectStyle, borderColor: selectedDayId ? '#f29b11' : '#333' }} 
                    disabled={isLoading}
                    aria-label="Select Training Day"
                >
                    <option value="">{isLoading ? 'Loading Days...' : '- Select Training Day -'}</option>
                    {(programDays || []).map(day => (
                        <option key={day.id} value={day.id}>{day.label}</option>
                    ))}
                </select>
            )}
        </div>
    );
};
